<template>
  <el-form
    v-loading="loading"
    element-loading-text="拼命加载中"
    :model="ruleForm"
    :rules="type == 'add' ? addRules : editRules"
    ref="ruleForm"
    label-width="80px"
    class="demo-ruleForm"
    size="mini"
  >
    <div class="from-style">
      <div>
        <el-form-item label="名称" prop="name">
          <el-input
            autocomplete="off"
            v-model="ruleForm.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="账户" prop="accountName">
          <el-input
            autocomplete="off"
            v-model="ruleForm.accountName"
            placeholder="请输入账户"
            oninput="value=value.replace(/[^\x00-\xff]/g, '')"
          >
            <template v-slot:append>@{{ systemName }}</template>
          </el-input>
        </el-form-item>
        <el-form-item autocomplete="off" label="密码" prop="password">
          <el-input
            v-model="ruleForm.password"
            show-password
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属角色" prop="role_id">
          <el-select
            v-model="ruleForm.role_id"
            clearable
            placeholder="请选择角色"
            @change="roleChange"
          >
            <el-option
              v-for="item in editRole"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门" prop="baranch_id">
          <!-- :props="props" -->
          <el-cascader
            v-model="ruleForm.baranch_id"
            :options="editBaranch"
            clearable
            :show-all-levels="false"
            placeholder="请选择部门"
            size="mini"
            @change="handleDaranch"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :disabled="accessControl.accountmanagemodify == true"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button @click="resetForm('ruleForm')">关闭</el-button>
        </el-form-item>
      </div>
      <div class="authority">
        <el-form-item label="操作权限:" prop="right">
          <el-scrollbar
            v-loading="treeLoading"
            element-loading-text="正在加载中!"
            style="border: 1px solid #e6e6e6; width: 360px; height: 82vh"
          >
            <el-tree
              :data="rightTree"
              ref="editTree"
              show-checkbox
              node-key="id"
              :props="defaultProps"
            >
            </el-tree>
          </el-scrollbar>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>
<script>
import { request } from '../dataApi/_request/index'
import Api from '../apis/api'
export default {
  props: {
    roleData: Array,
    formData: Object,
    baranchData: Array,
    type: String,
    tabName: String,
    systemName: String,
    destinationId: Number,
    systemData: Array,
    rightData: Array,
    localUserData: Object,
    accessControl: Object
  },
  created() {
    // 部门
    this.editBaranch = this.baranchData
    // 角色
    this.editRole = this.roleData
  },
  mounted() {
    this.gsdgsgagzdzx()
    // 表单 处理
    this.accountHandle()
    this.handleTreeData()
  },
  data() {
    return {
      loading: false,
      ruleForm: [],
      editBaranch: [],
      editRole: [],
      role_name: '',
      rightTree: [],
      untreatedData: [],
      unsystemData: [],
      oldcheckedId: [],
      clearDisable: [],
      disableId: [],
      allCheckData: {},
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      treeLoading: false,
      addRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        accountName: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      editRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        accountName: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    gsdgsgagzdzx() {
      let params = {
        method: 'post',
        url: Api.getOutLink,
        data: {
          destination_id: this.formData.destination_id
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }
      request(params).then((res) => {
        if (res.total != 0) {
          this.handleTreeData(res.data)
        }
      })
    },
    accountHandle() {
      this.allCheckData = this.formData.right
      let form = _.cloneDeep(this.formData)

      // 置空密码
      form.password = ''
      let account = form.account
      // 处理账户@后的值
      let accountsplit = account.split('@')
      form.accountName = accountsplit[0]

      let roleId = form.role_id
      let foundValue = this.roleData.find((item) => item.value === roleId)
      if (foundValue) {
        roleId = foundValue.value
      } else {
        roleId = '0'
      }
      form.role_id = roleId
      console.log(form, 'formform')

      if (form.role_id == '0') {
        form.role_id = ''
      }
      form.systemName = this.systemName

      this.ruleForm = form
    },
    // 保存 用户信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true

          let currentRight = this.getCurrentRight()
          let currentSystem = this.getCurrentSystem()
          this.ruleForm.right = JSON.stringify(currentRight)
          this.ruleForm.system = currentSystem.join(',')
          this.ruleForm.account =
            this.ruleForm.accountName + '@' + this.ruleForm.systemName
          this.ruleForm.destination_id = this.destinationId
          this.ruleForm.role = 'ROLE_USER'

          if (this.type == 'add') {
            let params = {
              method: 'post',
              url: Api.addNormalAccount,
              data: {
                data: this.ruleForm
              },
              headers: {
                'Content-Type':
                  'application/x-www-form-urlencoded; charset=UTF-8'
              }
            }
            request(params)
              .then((res) => {
                if (res.errcode == 0) {
                  this.ruleForm.row_id = res.data.result
                  this.$emit('update', this.ruleForm, this.tabName, 'add')
                  this.$message({
                    message: '新增成功',
                    type: 'success'
                  })
                } else {
                  this.$message.error('新增失败')
                }
                this.loading = false
              })
              .catch((error) => {
                this.loading = false
              })
          } else {
            let right = this.handleCheck()
            this.ruleForm.right = JSON.stringify(right)

            let params = {
              method: 'post',
              url: Api.modifyNormalAccount,
              data: {
                data: this.ruleForm
              },
              headers: {
                'Content-Type':
                  'application/x-www-form-urlencoded; charset=UTF-8'
              }
            }
            request(params)
              .then((res) => {
                if (res.errcode == 0) {
                  this.$emit('update', this.ruleForm, this.tabName)
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  })
                } else {
                  this.$message.error('修改失败')
                }
                this.loading = false
              })
              .catch((error) => {
                this.loading = false
              })
          }
        } else {
          return false
        }
      })
    },
    handleCheck() {
      // 次账户下的所有权限
      let editRigh = JSON.parse(this.allCheckData)

      // 页面中被勾选中的 系统数据
      let checkedList = this.$refs.editTree.getCheckedNodes(false, true)
      console.log(checkedList, '勾选中的值')
      console.log(this.localUserData, 'localUserData')

      // 没有勾选的情况下
      if (checkedList.length == 0) {
        let identify
        // 拿系统标识符
        if (this.localUserData.identify) {
          identify = this.localUserData.identify.split(',')
        } else {
          identify = this.localUserData.data.identify.split(',')
        }

        console.log(identify, 'identify')
        if (Object.prototype.hasOwnProperty.call(editRigh, identify[0])) {
          // delete editRigh[identify]
          editRigh[identify[0]] = []
        }
      } else {
        let systemList = []
        // 系统名称
        checkedList.forEach((item) => {
          if (item.parent_id == '-1') {
            systemList.push(item.id)
          }
        })

        let currentRight = {}
        systemList.forEach((system) => {
          currentRight[system] = []
          checkedList.forEach((item) => {
            if (item.parent_id != '-1' && item.id.indexOf(system) >= 0) {
              currentRight[system].push(item.id.replace(system + '-', ''))
            }
          })
        })

        for (let key in currentRight) {
          // 查找是否有对应的 key
          if (Object.prototype.hasOwnProperty.call(editRigh, key)) {
            console.log('key值相同')
            editRigh[key] = currentRight[key]
          } else {
            console.log('key值不相同')
            // 新增权限 拼接到 right 中
            editRigh = { ...editRigh, ...currentRight }
          }
        }
      }
      return editRigh
    },
    //获取当前权限
    getCurrentRight() {
      //let checkedNodeList = this.$refs.editTree.getCheckedNodes(false, true);
      let checkedList = this.$refs.editTree.getCheckedNodes(false, true) //JSON.parse(JSON.stringify(checkedNodeList));
      let systemList = []
      checkedList.forEach((item) => {
        if (item.parent_id == '-1') {
          systemList.push(item.id)
        }
      })
      let currentRight = {}
      systemList.forEach((system) => {
        currentRight[system] = []
        checkedList.forEach((item) => {
          if (item.parent_id != '-1' && item.id.indexOf(system) >= 0) {
            currentRight[system].push(item.id.replace(system + '-', ''))
          }
        })
      })
      return currentRight
    },
    //获取当前系统
    getCurrentSystem() {
      //let checkedNodeList = this.$refs.editTree.getCheckedNodes(false, true);
      let checkedList = this.$refs.editTree.getCheckedNodes(false, true) //JSON.parse(JSON.stringify(checkedNodeList));
      let systemList = []
      checkedList.forEach((item) => {
        if (item.parent_id == '-1') {
          systemList.push(item.id)
        }
      })
      return systemList
    },
    // 处理权限节点
    handleTreeData(ssss) {
      this.treeLoading = true
      this.rightTree = []
      let system = this.systemData
      let right = this.rightData
      let fatherData = this.findFatherTree(system)
      let sonData = this.findSonTree(right)
      ssss?.forEach((link) => {
        fatherData.forEach((ther) => {
          if (ther.row_id == link.system_id && link.out_link_name) {
            ther.label = link.out_link_name
          }
        })
      })
      fatherData.forEach((item) => {
        sonData.forEach((events) => {
          if (item.id === events.system) {
            if (!item['children']) {
              item['children'] = [events]
            } else {
              item['children'].push(events)
            }
          }
        })
      })

      // 树结构
      this.rightTree = fatherData
      this.treeLoading = false
      //设置树节点选中
      if (this.type == 'edit') {
        let trNode = {}
        try {
          trNode = JSON.parse(this.ruleForm.right)
        } catch (err) {
          console.log(err)
        }
        if (trNode != '{}') {
          //= trNode
          let checkedIdList = []
          for (let key in trNode) {
            let sysNode = trNode[key]
            checkedIdList.push(key)
            trNode[key].forEach((item) => {
              checkedIdList.push(key + '-' + item)
            })
          }
          this.$refs.editTree.setCheckedKeys(checkedIdList, true)
          //解决父选框选中时，也会导致子选项都会被选中的问题
          setTimeout(() => {
            // 获取树中所有选中的值
            let defaultCheckAll = this.$refs.editTree.getCheckedKeys()
            // 通过对比树所有选中的值（defaultCheckAll）和详情返回选中的值（checkedIdList）去取两个数组的差集
            let deleteArr = defaultCheckAll.filter(
              (item) => !checkedIdList.some((item_1) => item_1 === item)
            )
            // 遍历去掉不需要选中的值
            deleteArr.map((item) => {
              this.$refs.editTree.setChecked(item, false)
            })
          }, 200)
          if (this.ruleForm.role_id > 0) {
            this.getRoleRight(this.ruleForm.role_id, true)
          }
        }
      }
    },
    //获取角色权限数据
    getRoleRight(id, isOnlyDisable = false) {
      // getRole({ row_id: id })
      let params = {
        method: 'post',
        url: Api.getRole,
        data: {
          row_id: id
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }
      request(params).then((res) => {
        if (res.errcode == 0 && res.data && res.data.length > 0) {
          let roleRight = {}
          try {
            roleRight = JSON.parse(res.data[0].right)
          } catch (err) {
            console.log(err)
          }
          let checkedKeyList = this.$refs.editTree.getCheckedKeys()
          let checkedKeyPreList = _.cloneDeep(checkedKeyList)
          for (let key in roleRight) {
            let sysName = key
            let sysNode = roleRight[key]
            this.disableId.push(key)
            checkedKeyList.push(key)
            sysNode.forEach((item) => {
              this.disableId.push(key + '-' + item)
              checkedKeyList.push(key + '-' + item)
            })
          }
          if (!isOnlyDisable) {
            this.$refs.editTree.setCheckedKeys(checkedKeyList)
            //解决父选框选中时，也会导致子选项都会被选中的问题
            setTimeout(() => {
              // 获取树中所有选中的值
              let defaultCheckAll = this.$refs.editTree.getCheckedKeys()
              // 通过对比树所有选中的值（defaultCheckAll）和详情返回选中的值（checkedIdList）去取两个数组的差集
              let deleteArr = defaultCheckAll.filter(
                (item) => !this.disableId.some((item_1) => item_1 === item)
              )
              deleteArr = deleteArr.filter(
                (item) => !checkedKeyPreList.some((item_1) => item_1 === item)
              )
              // 遍历去掉不需要选中的值
              deleteArr.map((item) => {
                this.$refs.editTree.setChecked(item, false)
              })
            }, 200)
          }
          this.disabledFn(this.rightTree, this.disableId)
        }
      })
    },
    // 切换角色
    roleChange(id) {
      //取消角色权限禁用
      this.disabledFn(this.rightTree, this.disableId, false)
      //取消角色权限选中
      let checkedKeyList = this.$refs.editTree.getCheckedKeys()
      let deleteArr = checkedKeyList.filter((item) =>
        this.disableId.some((item_1) => item_1 === item)
      )
      deleteArr.map((item) => {
        this.$refs.editTree.setChecked(item, false)
      })
      this.disableId = []
      if (id) {
        this.getRoleRight(id)
      }
    },
    handleDaranch(val) {
      if (val == null) {
        this.ruleForm.baranch_id = '0'
      } else {
        this.ruleForm.baranch_id = val[0]
      }
    },
    //禁用或反禁用
    disabledFn(treeData, disabledIds, flag = true) {
      treeData.forEach((item) => {
        // 找到对应的id
        if (disabledIds.includes(item.id)) {
          this.$set(item, 'disabled', flag)
          // Reflect.set(item, 'disabled', flag)
        }
        if (item.children) {
          this.disabledFn(item.children, disabledIds, flag)
        }
      })
    },
    // 处理子 树节点
    findSonTree(data) {
      let rightArray = []
      data.forEach((items) => {
        rightArray.push({
          id: items.system + '-' + items.right_value,
          label: items.remark,
          row_id: items.row_id,
          parent_id: items.parent_id,
          system: items.system,
          right_value: items.right_value,
          disabled: false
        })
      })
      const RightTree = arrayToTree(rightArray)
      function arrayToTree(items) {
        const result = [] // 存放结果集
        const itemMap = {} //
        for (const item of items) {
          const id = item.row_id
          const parent_id = item.parent_id
          if (!itemMap[id]) {
            itemMap[id] = {
              children: []
            }
          }
          itemMap[id] = {
            ...item,
            children: itemMap[id]['children']
            // children: [],
          }
          const treeItem = itemMap[id]
          if (parent_id === '0') {
            result.push(treeItem)
          } else {
            if (!itemMap[parent_id]) {
              itemMap[parent_id] = {
                children: []
              }
            }
            itemMap[parent_id].children.push(treeItem)
          }
        }
        return result
      }
      return RightTree
    },
    // 处理父 树节点
    findFatherTree(parents) {
      let tree = []
      parents.forEach((item) => {
        let node = {
          id: item.identify,
          identify: item.identify,
          row_id: item.id,
          label: item.label,
          parent_id: '-1',
          disabled: false
        }
        tree.push(node)
      })
      return tree
    },
    resetForm(formName) {
      this.$emit('update', '', this.tabName, 'close')
    }
  }
}
</script>
<style lang="scss" scoped>
.from-style {
  height: 100%;
  display: flex;
  margin-top: 14px;
  :deep(.el-input--mini) {
    width: 344px;
  }
  .authority {
    width: 40%;
    margin-left: 10%;
  }
  :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #06c1a8;
    border-color: #06c1a8;
  }

  :deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner) {
    background-color: #f2f6fc;
    border-color: #dcdfe6;
  }
}
</style>
